import {
  SAVE_TEMPLATE_CAT_RELEVANCE,
  SAVE_TEMPLATE_TOPIC_RELEVANCE,
  ADD_TEMPLATE_CATEGORY,
  REMOVE_TEMPLATE_CATEGORY,
  ADD_TEMPLATE_TOPIC,
  REMOVE_TEMPLATE_TOPIC,
  SAVE_TEMPLATE_CATEGORY_ORDER,
  SAVE_TEMPLATE_TOPIC_ORDER,
  SET_TEMPLATE_EDITING,
  SET_DEFAULT_TEMPLATES,
  SET_USER_TEMPLATES,
  SET_USER_TEMPLATES_STATUS,
  SAVE_TEMPLATE_TITLE,
  SET_TEMPLATE_ERRORS_IDS
} from './action';

import {getDefaultTemplates, getUserTemplates} from '../services/templates';

const saveTemplateCatRelevance=(relevance,index)=>{
  return {
    type: SAVE_TEMPLATE_CAT_RELEVANCE,
    relevance,
    index
  }
}

const saveTemplateCatOrder=(order,index)=>{
  return {
    type: SAVE_TEMPLATE_CATEGORY_ORDER,
    order,
    index
  }
}

const saveTemplateTopicRelevance=(relevance,index,index1)=>{
  return {
    type: SAVE_TEMPLATE_TOPIC_RELEVANCE,
    relevance,
    index,
    index1
  }
}

const saveTemplateTopicOrder=(order,index,index1)=>{
  return {
    type: SAVE_TEMPLATE_TOPIC_ORDER,
    order,
    index,
    index1
  }
}

const saveTemplateTitle=(title)=>{
  return {
    type: SAVE_TEMPLATE_TITLE,
    title
  }
}

const addTemplateCategory=(category)=>{
  return {
    type: ADD_TEMPLATE_CATEGORY,
    category
  }
}

const removeTemplateCategory=(index)=>{
  return {
    type: REMOVE_TEMPLATE_CATEGORY,
    index
  }
}

const addTemplateTopic=(topicObj, index)=>{
  return {
    type: ADD_TEMPLATE_TOPIC,
    topicObj,
    index
  }
}

const removeTemplateTopic=(index,index1)=>{
  return {
    type: REMOVE_TEMPLATE_TOPIC,
    index,
    index1
  }
}

const setTemplateEditing=(template)=>{
  return {
    type: SET_TEMPLATE_EDITING,
    template
  }
}

const setDefaultTemplates=(templates)=>{
  return {
    type: SET_DEFAULT_TEMPLATES,
    defaultTemplates:templates
  }
}

const setUserTemplates=(templates)=>{
  return {
    type: SET_USER_TEMPLATES,
    userTemplates:templates
  }
}

const setUserTemplatesStatus=(sts)=>{
  return {
    type: SET_USER_TEMPLATES_STATUS,
    userTemplateStatus:sts
  }
}

const startGetDefaultTemplate=(renew=false)=>{

  return async (dispatch)=>{
    try {
      const defaultTemplates = await getDefaultTemplates(renew);
      dispatch(setDefaultTemplates(defaultTemplates));
    } catch(e) {

    }
  }
}

const startGetUserTemplates=()=>{

  return async (dispatch)=>{
    try {
      dispatch(setUserTemplatesStatus('loading'));
      const userTemplates = await getUserTemplates();
      dispatch(setUserTemplatesStatus(''));
      dispatch(setUserTemplates(userTemplates));
    } catch(e) {
      dispatch(setUserTemplatesStatus(''));

    }
  }
}

const setTemplateErrorsIds=(errorIds)=>{
  return {
    type: SET_TEMPLATE_ERRORS_IDS,
    errorIds
  }
}


export {
  saveTemplateCatRelevance,
  saveTemplateCatOrder,
  saveTemplateTopicRelevance,
  saveTemplateTopicOrder,
  addTemplateCategory,
  removeTemplateCategory,
  addTemplateTopic,
  setTemplateEditing,
  setDefaultTemplates,
  startGetDefaultTemplate,
  startGetUserTemplates,
  removeTemplateTopic,
  setTemplateErrorsIds,
  setUserTemplatesStatus,
  saveTemplateTitle
}
